export const SIGNUP_ROOT_ROUTE = 'SignUp'

export const subRoutes = {
  additionalInformation: `/additional-information`,
  contactDetailsError: `/error`,
  password: `/password`,
  verificationOptions: `/options`,
  security: `/security`,
  phoneNumberVerification: `/phone-number-verification`,
  depositLimit: `/deposit-limit`,
  depositBonus: `/deposit-bonus`,
  driversLicence: `/licence`,
  passport: `/passport`,
  medicare: `/medicare`,
  failGeneral: `/fail-general`,
  signUpUnsuccessful: `/unsuccessful`,
  signUpComplete: `/complete`,
  verificationAccountInformation: '/verification-account/information',
  verificationAccountComplete: '/verification-account/complete',
} as const

const withRoot = (path: string) => `/${SIGNUP_ROOT_ROUTE}${path}`
export const routes = {
  any: withRoot('/*'),
  contactDetails: `/${SIGNUP_ROOT_ROUTE}`,
  additionalInformation: withRoot(subRoutes.additionalInformation),
  contactDetailsError: withRoot(subRoutes.contactDetailsError),
  password: withRoot(subRoutes.password),
  verificationOptions: withRoot(subRoutes.verificationOptions),
  security: withRoot(subRoutes.security),
  depositLimit: withRoot(subRoutes.depositLimit),
  phoneNumberVerification: withRoot(subRoutes.phoneNumberVerification),
  depositBonus: withRoot(subRoutes.depositBonus),
  driversLicence: withRoot(subRoutes.driversLicence),
  passport: withRoot(subRoutes.passport),
  medicare: withRoot(subRoutes.medicare),
  failGeneral: withRoot(subRoutes.failGeneral),
  signUpUnsuccessful: withRoot(subRoutes.signUpUnsuccessful),
  signUpComplete: withRoot(subRoutes.signUpComplete),
  verificationAccountInformation: withRoot(subRoutes.verificationAccountInformation),
  verificationAccountComplete: withRoot(subRoutes.verificationAccountComplete),
  home: `/`,
} as const
